<template>
  <div class='show-place-element row' :class='{ selected: place.selected }'>
    <b-col lg='4'>
      <img :src="place.imageSrc || require('no-image.png')" alt=''>
    </b-col>
    <b-col lg='8'>
      <span class='place-order'>{{ place.order }} - </span> {{ place.name }}
      <a href='#' @click.prevent='changeReportSource(place.placeId)' :id='`change-report-source-${place.placeId}`'>
        <i class='fa fa-eye' aria-hidden='true' />
      </a>
      <br>
      <template v-if='place.address'><small>{{ place.address }}</small></template>
      <template v-else><b class='text-dark'>Service Area Business</b></template>

      <div v-if="place.categories && place.categories.length" class="mt-1 font-size-12">
        <span class="d-block font-size-14">Categories:</span>
        {{ place.categories.join(', ') }}
      </div>

      <b-tooltip :target='`change-report-source-${place.placeId}`' triggers='hover'>
        Show the Business Ranks on Geogrid
      </b-tooltip>
    </b-col>
  </div>
</template>

<script>
import { updateSearchParams } from '../../../common/search_params'

export default {
  props: {
    place: Object
  },
  data() {
    return {
      selected: false
    }
  },
  watch: {
    'place.selected'(val) {
      if (val) {
        this.$el.scrollIntoView({ behavior: 'smooth' })
      }
    }
  },
  methods: {
    changeReportSource(id) {
      updateSearchParams({ placeId: id })
    }
  }
}
</script>

<style scoped lang='scss'>
  .show-place-element {
    background: #efefef;
    padding: 15px 0;
    border-radius: 5px;
    margin-bottom: 5px;
    border: 3px solid transparent;

    &.selected {
      border: 3px solid #ccc;
    }
  }
  .place-order {
    font-weight: bold;
  }
  .show-place-element img {
    width: 120px;
    height: 90px;
    object-fit: cover;
  }
</style>
